import PhotoCaptureModal from './PhotoCaptureModal'

export { PhotoCaptureModal }
export default PhotoCaptureModal
